<template>
    <md-card class="emailValidation">
        <md-card-content>
            <div class="flex justify-center">
                <font-awesome-icon :icon="['fas', 'envelope-circle-check']" class="text-primary" size="5x" />
            </div>
            <div class="flex justify-center mt-3 mb-3">
                <span class="text-lg font-bold text-primary-dark-100" v-html="$t('registration.validate-email.title')" />
            </div>
            <p class="text-base text-center text-primary-dark-100">
                {{ $t('registration.validate-email.description', { email: email }) }}
            </p>
            <div class="flex justify-center mt-4">
                <input
                    v-for="(ch, i) in code"
                    :key="i"
                    :ref="'code' + i"
                    type="text"
                    class="block w-10 mr-2 bg-white border border-gray-200 text-primary-dark-100 text-sm rounded-md block p-1.5 text-center"
                    maxlength="1"
                    autocomplete="one-time-code"
                    inputmode="numeric"
                    v-model="code[i]"
                    @input="onInput(i, $event)"
                    @keydown.backspace="onBackspace(i, $event)"
                    @paste="onPaste(i, $event)"
                    :disabled="loading"
                >
            </div>
            <div class="my-2 text-center text-xs text-red-500" v-if="!!showError" v-html="message" />
            <div class="mt-4 text-center cursor-pointer">
                <a class="text-xs !text-primary-dark-100 !underline " @click="sendEmailCode">{{ $t('registration.validate-email.resend-code') }}</a>
            </div>
            <div class="mt-4 text-center">
                <a class="text-xs !text-primary-dark-100">{{ $t('registration.validate-email.check-in-spam') }}</a>
            </div>
            <md-snackbar :md-active.sync="showSnackbar">
                <span>{{ $t(message) }}</span>
            </md-snackbar>
        </md-card-content>
    </md-card>
</template>

<script>
export default {
    props: {
        email: {
            type: String,
            //required: true, //TODO
            default: 'test@example.com',
        },
        returnLocation: {
            type: String,
            default: '/',
        },
    },
    data() {
        return {
            isValid: false,
            code: ['', '', '', ''],
            message: '',
            showSnackbar: false,
            loading: false,
            showError: false
        };
    },
    mounted() {
        this.sendEmailCode();
    },
    methods: {
        sendEmailCode() {
            this.code = ['', '', '', ''];
            axios.post('/api/user/email/send-mail-code', { email: this.email })
                .then(response => {
                    this.message = response.data.message;
                    this.showSnackbar = true;
                })
                .catch(error => {
                    this.message = this.$t('registration.validate-email.resend-failure');
                    this.showSnackbar = true;
                });
        },  
        checkEmailCode() {
            this.loading = true;
            this.showError = false;
            axios.post('/api/user/email/check-mail-code', { code: this.code.join('') })
                .then(response => {
                    this.message = response.data.message;
                    this.showSnackbar = true;
                    this.$nextTick(() => {
                        window.location = this.returnLocation;
                    });
                })
                .catch(error => {
                    this.message = this.$t('registration.validate-email.error');
                    this.showError = true;
                }).finally(() => {
                    this.loading = false;
                });
        },
        onInput(index, event) {
            // Ensure only one character is kept
            const val = (event.target.value || '').toString();
            this.code.splice(index, 1, val.slice(-1));

            // Auto-advance if filled
            if (this.code[index] && index < 3) {
                const next = this.$refs['code' + (index + 1)];
                if (next && next[0].focus) next[0].focus();
            }
            // If last field is filled, automatically trigger code check
            if (index === 3 && this.code[index]) {
                this.checkEmailCode();
            }
        },
        onBackspace(index, event) {
            const current = (this.code[index] || '').toString();
            if (!current && index > 0) {
                event.preventDefault();
                const prev = this.$refs['code' + (index - 1)];
                if (prev && prev[0].focus) {
                    this.code.splice(index - 1, 1, '');
                    prev[0].focus();
                }
            }
        },
        onPaste(index, event) {
            if (index !== 0) return; // Only handle paste on the first input
            const raw = (event.clipboardData && event.clipboardData.getData('text')) || '';
            if (!raw) return;
            event.preventDefault();

            const chars = raw.replace(/\s+/g, '').slice(0, 4).split('');
            for (let i = 0; i < 4; i += 1) {
                this.code.splice(i, 1, chars[i] || '');
            }


            // If all fields are filled from paste, automatically trigger code check
            if (chars.length === 4 && this.code.every(c => c)) {
                this.checkEmailCode();
            }

            // Focus next empty or last field
            this.$nextTick(() => {
                const filled = Math.min(chars.length, 3);
                const next = this.$refs['code' + filled];
                if (next && next[0].focus) next[0].focus();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~styles/_variables";
.emailValidation {
    input:focus,
    input:focus-visible {
        outline: none !important;
        box-shadow: none !important;
        border: 2px solid $primary-color !important;
    }
    input {
        color: $primary-color-dark;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/emailValidation.vue